// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flip-list-move {\n  transition: transform 0.5s;\n}\n.list-group-item {\n  cursor: move;\n}\n", ""]);
// Exports
module.exports = exports;
